module.exports = __webpack_public_path__ + "img/license.6fef4d00.png";